<script lang="ts" setup>
</script>

<template>
  <footer class="checkout-footer">
    <div class="checkout-footer__container">
      <CheckoutAssistance class="checkout-footer__assistance" />

      <div class="checkout-footer__payment">
        <div class="checkout-footer__heading">
          {{ $t('Pay with') }}
        </div>
        <AppPaymentIcons class="checkout-footer__payment-icons" />
      </div>

      <div class="checkout-footer__end">
        <FooterCopyright class="footer__copyright checkout-footer__copyright" />

        <FooterLegal class="checkout-footer__legal" />
      </div>
    </div>
  </footer>
</template>

<style>
@import url("~layers/components/Checkout/Footer.css");
</style>
